import { Button } from '@wot/components'
import { Calendar,  RocketIcon, User } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const LearningSteps = () => {
    const navigate = useNavigate();
  return (
    <div className='container mx-auto py-10'>
          <div className='flex items-center flex-col gap-3  max-w-2xl mx-auto'>
          <h3 className='text-2xl md:text-4xl lg:text-5xl font-bold text-center '>Explore Our Online Classes By Subject</h3>
          <p className='text-lg md:text-xl text-center'>Getting Started with personlized online tutoring has never been easier</p>
          </div>
         <div className="mt-16 flex flex-col items-center w-full">
           <div className="w-full flex flex-col md:flex-row justify-between  items-center gap-8 md:gap-4 lg:gap-8 relative">
             {/* Step 1 */}
             <div className="flex flex-col items-center text-center flex-1 max-w-xs relative">
               <div className="bg-blue-200 rounded-full w-20 h-20 flex items-center justify-center mb-4 shadow-lg z-10">
                  <User size={34} className='text-blue-600'/>
               </div>
               {/* Connector to Step 2 */}
               <div className="hidden lg:block absolute top-[20%] right-[-100%] w-[430px] h-1">
                 <div className="border-t-2 border-gray-300 w-full"></div>
               </div>
               <div className="text-3xl text-gray-400 font-semibold mb-1">01</div>
               <div className="font-bold text-2xl mb-1">Sign Up Free</div>
               <div className="text-gray-500 text-base">Create your account in less than 2 minutes.</div>
             </div>
            
             {/* Step 2 */}
             <div className="flex flex-col items-center text-center flex-1 max-w-xs relative">
               <div className="bg-green-200 rounded-full w-20 h-20 flex items-center justify-center mb-4 shadow-lg z-10">
                  <Calendar size={34} className='text-green-700'/>
               </div>
               {/* Connector to Step 3 */}
               <div className="hidden lg:block absolute top-[20%] right-[-100%] w-[430px] h-1">
                 <div className="border-t-2 border-gray-300 w-full"></div>
               </div>
               <div className="text-3xl text-gray-400 font-semibold mb-1">02</div>
               <div className="font-bold text-2xl mb-1">Book Your Free 1:1 Class</div>
               <div className="text-gray-500 text-base">Select a subject & tutor that fits your needs.</div>
             </div>

             {/* Step 3 */}
             <div className="flex flex-col items-center text-center flex-1 max-w-xs relative">
               <div className="bg-purple-200 rounded-full w-20 h-20 flex items-center justify-center mb-4 shadow-lg z-10">
                  <RocketIcon size={34} className='text-purple-800'/>
               </div>
               <div className="text-3xl text-gray-400 font-semibold mb-1">03</div>
               <div className="font-bold text-2xl  mb-1">Start Learning Live</div>
               <div className="text-gray-500 text-base">Join interactive classes & track your progress.</div>
             </div>
           </div>

           <div className='pt-10'>
              <Button text='Book a Free Trial' size='lg' className='!py-6 !px-10 !text-lg' onClick={()=>navigate('/booktrail')}/>
           </div>
       
    </div>
    </div>
  )
}

export default LearningSteps
